import config from 'config';
import { authHeader } from '@mobile/services/user';
import axios from '@mobile/util/axios';

export default {
    getAll,
    get,
};

async function get(checklistId) {
    const response = await axios.get(
        `${config.apiUrl}/${config.apiVersion}/checklists/${checklistId}`,
        { headers: authHeader() },
    );

    if (response && response.status === 200) {
        return response.data;
    }
}

async function getAll() {
    const response = await axios.get(
        `${config.apiUrl}/${config.apiVersion}/checklists`,
        { headers: authHeader() },
    );

    if (response && response.status === 200) {
        return response.data;
    }
}
